import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../contexts/I18nContext';

export const SessionRecovery = () => {
  const { refreshTokens } = useAuth();
  const { t } = useI18n();
  const [isRetrying, setIsRetrying] = useState(false);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md" role="alert">
        <h2 className="text-xl font-semibold text-gray-900">{t('protected.sessionUnavailable')}</h2>
        <p className="mt-2 text-sm text-gray-600">{t('protected.sessionRetryDescription')}</p>
        <button
          className="btn-primary mt-6"
          disabled={isRetrying}
          onClick={async () => {
            setIsRetrying(true);
            try {
              await refreshTokens();
            } catch {
              /* The context retains the retry state. */
            } finally {
              setIsRetrying(false);
            }
          }}
        >
          {t(isRetrying ? 'protected.refreshing' : 'protected.retrySession')}
        </button>
      </div>
    </div>
  );
};
